import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService {
    private static hasError: boolean = false;
    private static lastError: any;

    constructor() { 

    }

    handleError(error) {
        ErrorHandlerService.lastError = error;
        ErrorHandlerService.hasError = true;
        console.error("Form Builder Error: ", error.message);
        console.error(error);
    }

    getLastError() {
        return ErrorHandlerService.lastError;
    }

    hasErrors() {
        return ErrorHandlerService.hasError;
    }

    resetErrors() {
        ErrorHandlerService.hasError = false;
    }
}
